{
  "id": 23,
  "location": "paris",
  "difficulty": "normal",
  "moves": 24,
  "kinds": 6,
  "goals": [
    { "type": "mud" }
  ],
  "stars": [2710, 3980],
  "board": [
    ". . . . . . . .",
    ". . . . . . . .",
    "x x x x x x x x",
    "X X X X X X X X",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.767, "movesLeft": 6.1, "closeLosses": 0.203, "target": 0.72 }
}
